import { put, call, select } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';
import { storage } from 'storage';

import * as Api from 'api';
import * as Actions from 'actions';
import * as ActionTypes from 'constants';

/***************************** Selectors ************************************/

export const getUsers = state => (state.users);
export const getRoles = state => (state.roleManagement)

/***************************** Subroutines ************************************/

function *initUser(action) {
	try {
		yield put(Actions.toggleInitFlag(true))
		let users = yield select(getUsers)
		let updated_user;
		updated_user = yield call(Api.getUserById, action.payload);
		yield put(Actions.updateTmpUser(updated_user));
		if(users.user.is_admin) {
			if(updated_user.owner_account || users.proxy_account) {
				let account = updated_user.owner_account || updated_user._id;
				let roles = yield call(Api.getRolesInAccount, account)
				yield put(Actions.setTmpUserRoles(roles))
			}
		}
		let features = yield call(Api.getUsersFeatures, updated_user._id)

		yield put(Actions.setTmpUserFeatures(features))
		yield put(Actions.updateFeaturesOwnerType('User'))
		yield put(Actions.showEditUser(updated_user))
		yield put(Actions.toggleInitFlag(false))
	}
	catch(e) {
		yield put(Actions.toggleInitFlag(false))
		console.log(e)
	}
}

function * initProxyLogin(action) {
	try {
    const { user } = yield select(getUsers);
    console.log(user);
    if(user.is_admin) {
      const current_token = yield storage.getItem('token');
      const { token } = yield call(Api.login, action.payload.username, null, current_token);

      yield storage.setItem('token', token);
      yield storage.setItem('username', action.payload.username);
      setTimeout(f => window.location.reload(), 400);
    }

		// yield put(Actions.toggleInitFlag(true))
		// let account = action.payload.owner_account || action.payload._id;
		// yield put(Actions.loginProxyAccount(action.payload))
		// let roles = yield call(Api.getRolesInAccount, action.payload._id)
		// yield put(Actions.setTmpUserRoles(roles))
		// yield put(Actions.joinSocketChannel(`account-${account}`))
	}
	catch(ex) {
		yield put(Actions.notify({message : ex.message || ex}))
		yield put(Actions.toggleInitFlag(false))
	}
}

function *initializeUsersAndRoles(action) {
	let proxy_account = action.payload
	try {
		yield put(Actions.toggleInitFlag(true));
		let { settings, children } = yield call(Api.getUserChildren, null, proxy_account);
		yield put(Actions.initChildren(children));
		let roles;
		if(proxy_account) {
			roles = yield call(Api.getRolesInAccount, proxy_account._id)
			let features = yield call(Api.getUsersFeatures, proxy_account._id)
			proxy_account.features = features;
			yield put(Actions.updateProxyAccount(proxy_account))
		}
		else {
			roles = yield call(Api.fetchRoles);
		}
		yield put(Actions.initializeRoles(roles));
		yield put(Actions.toggleInitFlag(false));
	}
	catch(e) {
		yield put(Actions.toggleInitFlag(false))
		yield put(Actions.notify({message : (e.message ? e.message : e)}))
	}
}

function * editUser(action) {
	try {
		yield put(Actions.toggleInitFlag(true))
		let users = yield select(getUsers)
		yield put(Actions.hideEditUser())
		yield put(Actions.updateFeaturesOwnerType('Role'))
		if(users.user.is_admin && users.tmp_user_roles.length > 0) {
			yield put(Actions.setTmpUserRoles([]))
		}
		yield put(Actions.clearShowIndividualFeatures())
		if(users.proxy_account !== null) {
			yield put(Actions.sendSocketEmit({...action.payload, proxy_account : users.proxy_account}, 'edit-user'))
		}
		else {
			yield put(Actions.sendSocketEmit(action.payload, 'edit-user'))
		}
		if(!users.user.is_admin || (users.user.is_admin && users.proxy_account !== null)) {
			yield put(Actions.toggleInitFlag(false))
		}
	}
	catch(e) {
    yield put(Actions.notify({message : 'Error editing user'}))
    yield put(Actions.toggleInitFlag(false))
  }
}

function * storeEditedUser(action) {
  try {
  	let users = (yield select(getUsers))
    yield put(Actions.editUser(action.payload.user))
    yield put(Actions.toggleInitFlag(false))
  }
  catch(e) {
    console.log(e)
    yield put(Actions.toggleInitFlag(false))
  }
}

function * editUserFail(action) {
	try {
		yield put(Actions.notify({message : action.payload.message}))
		yield put(Actions.toggleInitFlag(false))
	}
	catch(e) {
    console.log(e)
    yield put(Actions.toggleInitFlag(false))
  }
}

function * initCreateUser() {
	try {
		let users = yield select(getUsers)
		if(users.proxy_account) {
			let roles = yield call(Api.getRolesInAccount, users.proxy_account._id)
			yield put(Actions.setTmpUserRoles(roles))
		}
		yield put(Actions.showCreateUser())
	}
	catch(ex) {
		console.log(ex.message || ex)
	}
}

function * createUser(action) {
	try {
		yield put(Actions.toggleInitFlag(true))
		let users = yield select(getUsers)
		if(users.user.is_admin && users.proxy_account) {
			yield put(Actions.sendSocketEmit({
				...action.payload,
				proxy_owner_account : users.proxy_account.owner_account || users.proxy_account._id,
				proxy_id : users.proxy_account._id
			}, 'create-user'))
		}
		else {
			let {role} = action.payload;
			if(users.user.is_admin && (role === 'System Admin' || role === 'Super Admin')) {
				action.payload.is_admin = true;
			}
			yield put(Actions.sendSocketEmit(action.payload, 'create-user'))
		}
	}
	catch(ex) {
		yield put(Actions.toggleInitFlag(false))
		yield put(Actions.notify({message : ex.message}))
	}
}

function * createUserSuccess(action) {
	try {
		yield put(Actions.hideCreateUser())
		yield put(Actions.addUser(action.payload.user))
		yield put(Actions.toggleInitFlag(false))
	}
	catch(ex) {
		console.log(ex.message || ex)
		yield put(Actions.toggleInitFlag(false))
	}
}

function * createUserFailed(action) {
	try {
		yield put(Actions.notify({message : action.payload.message || action.payload}))
		yield put(Actions.toggleInitFlag(false))
	}
	catch(ex) {
		yield put(Actions.notify({message : ex.message || ex}))
		yield put(Actions.toggleInitFlag(false))
	}
}

function * signupClientAdmin(action) {
	try {
		yield put(Actions.toggleInitFlag(true))
		let users = yield select(getUsers)
		const user = yield call(Api.signupClientAdmin, action.payload)
		if (!users.user || !users.user.is_admin) {
			yield put(Actions.login({
				username : action.payload.email,
				password : action.payload.password
			}))
			// yield put(Actions.init())
			yield put(Actions.toggleInitFlag(false))
		}
		else {
			yield put(Actions.hideCreateUser())
			yield put(Actions.toggleInitFlag(false))
		}
	}
	catch(ex) {
		yield put(Actions.notify({message : ex.message}))
		yield put(Actions.toggleInitFlag(false))
	}
}

function * deleteUser() {
	try {
		yield put(Actions.toggleInitFlag(true))
		yield put(Actions.hideDeleteUserPrompt());
		const users = yield select(getUsers);
		let auth_user = users.user;
		let updatedChildren = yield call(Api.deleteUser, users.tmp_user)
		yield put(Actions.removeUser(users.tmp_user._id, updatedChildren))
		yield put(Actions.hideDeleteUserPrompt());
		yield put(Actions.toggleInitFlag(false))
	}
	catch(ex) {
		yield put(Actions.toggleInitFlag(false))
		yield put(Actions.notify({message : ex.message}))
	}
}

function * initDashboard() {
	try {
		yield put(Actions.toggleInitFlag(true));
		let current_user = yield call(Api.fetchCurrentUser)
		yield put(Actions.updateUser(current_user))
		yield call(initChildren)
		let favorites = yield call(Api.fetchFavoriteMaps);
		yield put({ type: ActionTypes.FAVORITE_MAP_SUCCESS, payload: {favorites}});

		yield put(Actions.toggleInitFlag(false));
	}
	catch(e) {
		yield put(Actions.toggleInitFlag(false));
		console.log(e)
	}
}

function * initChildren() {
	try {
		let users = yield select(getUsers)
		let {settings, children} = yield call(Api.getUserChildren, {});
		if(users.proxy_account)
			yield put(Actions.updateProxyChildren(children))
		else
			yield put(Actions.initChildren(children));
	}
	catch(ex) {
		console.log(ex)
	}
}

function * beginPasswordReset(action) {
	try {
		yield call(Api.requestPasswordReset, action.payload)
		yield put(Actions.updateTmpUser({email : action.payload}))
		yield put(Actions.toggleFetchingTempHash(true))
	}
	catch(e) {
		yield put(Actions.notify({message : e.message || e}))
		yield put(Actions.toggleFetchingTempHash(false))
	}
}

function * tempHashValidation(action) {
	try {
		let {id, hash} = action.payload
		yield call(Api.validateTempHash, id, hash)
		yield put(Actions.toggleResettingPassword(true))
	}
	catch(ex) {
		yield notify({message : ex.message || ex})
	}
}

function * saveNewPassword(action) {
	try {
		let {_id, password, password_confirm, temp_hash} = action.payload;
		yield call(Api.setNewPassword, _id, password, password_confirm, temp_hash)
		yield put(Actions.push('/'))
		yield put(Actions.notify(
			{message : 'Password set successfully.'},
			{title : 'Success!',type : 'success'}
		))
	}
	catch(e) {
		yield put(Actions.notify(
			{message : e.message || e}))
	}
}

/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/

export function* usersWatcher() {
  yield* [
  	takeEvery(ActionTypes.BEGIN_INIT_USERS, initializeUsersAndRoles),
    takeEvery(ActionTypes.CREATE_USER_SUCCESS, createUserSuccess),
    takeEvery(ActionTypes.CREATE_USER_FAILED, createUserFailed),
    takeEvery(ActionTypes.BEGIN_DELETE_USER, deleteUser),
    takeEvery(ActionTypes.BEGIN_EDIT_USER_SAGA, initUser),
    takeEvery(ActionTypes.INIT_DASHBOARD, initDashboard),
    takeEvery(ActionTypes.INIT_USERS_CHILDREN, initChildren),
    takeEvery(ActionTypes.BEGIN_EDIT_USER, editUser),
    takeEvery(ActionTypes.EDIT_USER_SUCCESS, storeEditedUser),
    takeEvery(ActionTypes.EDIT_USER_FAILED, editUserFail),
    takeEvery(ActionTypes.INIT_CREATE_USER, initCreateUser),
    takeEvery(ActionTypes.BEGIN_CREATE_USER, createUser),
    takeEvery(ActionTypes.BEGIN_SIGNUP_CLIENT_ADMIN, signupClientAdmin),
    takeEvery(ActionTypes.INIT_PROXY_USER_LOGIN, initProxyLogin),
    takeEvery(ActionTypes.BEGIN_PASSWORD_RESET, beginPasswordReset),
    takeEvery(ActionTypes.BEGIN_TEMP_HASH_VALIDATION, tempHashValidation),
    takeEvery(ActionTypes.BEGIN_SAVE_NEW_PASSWORD, saveNewPassword)
  ]
}



// WEBPACK FOOTER //
// ./src/common/sagas/users.js